type Props = {
	resourceName: string;
};

/**
 * @example
 * ```tsx
 * <NameOfResourceBeingEdited resourceName="プラン" />
 * -> プラン を編集中
 * ````
 */
export const NameOfResourceBeingEdited = ({ resourceName }: Props) => {
	const text = resourceName || "名称未設定";

	return (
		<div className="flex max-w-[max-content] flex-wrap items-end gap-x-2">
			<h3 className="line-clamp-1 text-xl font-bold">{text}</h3>
			<p className="ml-auto">を編集中</p>
		</div>
	);
};
